import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BasePricingService } from "shared/cubiq-services/lookup/pricing/impl/BasePricingService";
import { ICellRendererAngularComp } from "@bfx/ag-grid-angular";
import { PricingService } from "shared/cubiq-services";
import { LadderRate } from "shared/cubiq-services/model/orders/LadderRate";
import { LadderPair } from "shared/cubiq-services/model/orders/LadderPair";

@Component({
  selector: "percent-away",
  templateUrl: "./html/PercentAwayRenderer.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PercentAwayRenderer implements ICellRendererAngularComp {
  public percentAway: string;
  public showStrike: boolean;
  public showInvert: boolean;
  public visible: boolean;

  constructor(
    public cd: ChangeDetectorRef,
    protected myBasePricingService: BasePricingService,
  ) {}

  // called on init
  agInit(params: any): void {
    this.doVal(params);
    this.cd.markForCheck();
  }

  doVal(params: any): boolean {
    this.visible =
      params.data.constructor.name !== LadderRate.name &&
      params.data.constructor.name !== LadderPair.name; // &&
    // params.data.constructor.name !== "LadderAggregate";

    if (!this.visible) {
      return false;
    }

    let newPercAway: string;
    let changed: boolean = false;
    let num: number = PricingService.clearStrikeThroughValue(params.getValue(params)) as number;

    if (isNaN(num)) {
      newPercAway = "--";
    } else {
      newPercAway = num.toFixed(2);
    }
    newPercAway += " %";
    if (this.percentAway != newPercAway) {
      changed = true;
      this.percentAway = newPercAway;
    }
    if (this.myBasePricingService) {
      if (this.myBasePricingService.isStrikethroughPercentAway(params.data)) {
        if (!this.showStrike) {
          changed = true;
        }
        this.showStrike = true;
      } else {
        if (this.showStrike == true) {
          changed = true;
        }
        this.showStrike = false;
      }
    }

    // if (changed) {
    //   if (params.eGridCell != null) {
    //     if (this.showStrike)
    //       params.eGridCell.title = '--- ' + this.percentAway + ' ---';
    //     else
    //       params.eGridCell.title = this.percentAway;
    //   }
    // }

    return changed;
  }

  refresh(params: any): boolean {
    if (this.doVal(params)) {
      this.cd.markForCheck();
    }

    return true;
  }
}
